module.exports = __webpack_public_path__ + "img/dance-test-icon12.f8f8cd2d.png";